export default __webpack_public_path__ + "static/media/video.426d4e13.m4v";